// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { EventListener } from "@lib/utilities/EventListener";
import { IEventListener } from "@lib/utilities/IEventListener";

/**
 * Provides an API for sending and receiving messages.
 */
export abstract class Socket
{
  protected readonly _onMessage: EventListener<(message: object) => void> = new EventListener();

  protected constructor()
  {
  }

  get onMessage(): IEventListener<(message: object) => void>
  {
    return this._onMessage;
  }

  abstract sendMessage(message: object): void;
}